import { render, staticRenderFns } from "./componyDetails.vue?vue&type=template&id=7119cd0d&scoped=true&"
import script from "./componyDetails.vue?vue&type=script&lang=js&"
export * from "./componyDetails.vue?vue&type=script&lang=js&"
import style0 from "./componyDetails.vue?vue&type=style&index=0&id=7119cd0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119cd0d",
  null
  
)

export default component.exports